<div (offClick)="toggle(false)"
     [offClickOff]="!openState.value">
    <!-- heading -->
    <div class="flex flex-middle cursor-pointer"
         (click)="toggle()">
        <!-- icon -->
        <div class="m-r-1"
             [lineHeightBy]="'p1'">
            <i class="icon-chevron-down icon-medium _rotateAnimation"
               [toggleClassBy]="openState"
               [toggleClass]="'_rotate'"></i>
        </div>
        <!-- title -->
        <div class="flex-grow w-12 s1">
            @if (titleTpl) {
            <ng-container *ngTemplateOutlet="titleTpl"></ng-container>
            }
        </div>
    </div>

    <!-- body -->
    <div class="pos-absolute top-100 m-t-2 z-1"
         style="left:0"
         [hideUp]="openState">
        <div class="bg-col-w p-a b-a b-col-5"
             style="border-radius: 12px;"
             [class._grid]="optionsAsGrid"
             [style.--number-of-rows]="numberOfRows">
            @for (option of options; track option) {
            <div class="cursor-pointer s1 _option"
                 [class.m-b-2]="!$last && !optionsAsGrid"
                 (click)="pick(option)">
                @if (optionTpl) {
                <ng-container *ngTemplateOutlet="optionTpl; context: { $implicit: option }"></ng-container>
                }
            </div>
            }
        </div>
    </div>
</div>